import { Component, OnInit, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-infrastructure-feedback-view',
  templateUrl: './infrastructure-feedback-view.component.html',
  styleUrls: ['./infrastructure-feedback-view.component.scss']
})
export class InfrastructureFeedbackViewComponent implements OnInit {

  constructor(private http: HttpClient, private ActivatedRoute: ActivatedRoute, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  list = null;

  ngOnInit() {
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];

      this.http.get<any>(this.api_endpoint+'/studentinfrastructurefeedbackbyid/' + `${id}`).subscribe(
        data => {
          this.list = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    });
  }

}
